<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	headerText="Import items from catalogue"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-file-plus'}"
>
	<ng-container dialogContent>
		<mat-stepper orientation="vertical" linear>
			<mat-step [stepControl]="chooseAssessmentStepControl" [editable]="false">
				<ng-template matStepLabel>{{ T.IMPORT_FROM_CATALOGUE_DIALOG_CHOOSE_ASSESSMENT | translate }}</ng-template>
				<sim-chip-autocomplete
					class="assessmentSelect"
					[dataType]="FetchDataType.Assessment"
					[searchFilters]="[{searchColumn: 'isCatalogue', searchTerms: ['true']}]"
					[pageSize]="10000"
					[formCtrl]="chooseAssessmentStepControl.controls.assessmentControl"
					[labelToken]="T.ASSIGN_ASSESSMENT_DIALOG_ASSESSMENT"
				/>
				@if (chooseAssessmentStepControl.controls.assessmentControl.hasError(AssessmentValidatorError)) {
					<mat-error class="assessmentSelectError">{{ T.IMPORT_FROM_CATALOGUE_DIALOG_ASSESSMENT_ERROR | translate }}</mat-error>
				}

				<button [disabled]="!chooseAssessmentStepControl.valid" mat-raised-button color="accent" matStepperNext>
					{{ T.BUTTON_NEXT | translate }}
				</button>
			</mat-step>

			<mat-step>
				<ng-template matStepLabel>{{ T.IMPORT_FROM_CATALOGUE_DIALOG_CHOOSE_ITEMS | translate }}</ng-template>

				@for (groupMapEntry of itemsToExportMap; track groupMapEntry[0]) {
					<mat-checkbox
						[checked]="areAllItemsChecked(groupMapEntry[1])"
						(change)="toggleAllItems(groupMapEntry[1], $event.checked)"
						>{{ groupMapEntry[1].groupName }}</mat-checkbox
					>

					@for (itemMapEntry of groupMapEntry[1].itemMap; track itemMapEntry[0]) {
						<mat-checkbox
							class="item"
							[checked]="itemMapEntry[1].checked"
							(change)="handleItemCheckboxClick(groupMapEntry[1], itemMapEntry[0], $event.checked)"
						>
							<sim-safe-html [html]="itemMapEntry[1].item.title" />
						</mat-checkbox>
					}
				}
				<button mat-raised-button color="accent" (click)="resetForm()">
					{{ T.BUTTON_GO_BACK | translate }}
				</button>
			</mat-step>
		</mat-stepper>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="warn" />
		<sim-button
			color="accent"
			(onClick)="doClose()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_SAVE"
			[disabled]="!chooseAssessmentStepControl.valid || !areAnyItemsChecked(itemsToExportMap)"
		/>
	</ng-container>
</sim-basic-material-dialog>
